export default __webpack_public_path__ + "static/media/jupiter.66de8b36.jpg";